









































import { napoleonHubNavigationItems } from '@src/app/mobile/helpers/navigation';
import { defineComponent } from '@vue/composition-api';
import { useVueRouter } from '@superbet-group/web.lib.vue-utilities';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';

export default defineComponent({
    name: 'HubNavigation',
    setup() {
        const { route } = useVueRouter();

        return {
            isNativeOverride: !!route.value?.query?.nativeApps,
            navigationItems: napoleonHubNavigationItems,
        };
    },
    components: {
        SdsIcon,
    },
});
